<template>
<div class="system-support">
  <div class="title">系统支持</div>
  <p class="content">请在企业微信中搜索 “IT技术支持” 获取帮助</p>
  <p class="range">支持范围：提供业务系统使用方面相关问题的咨询服务(软件方面)</p>
  <div class="footer">
    <p>在线时间</p>
    <p>9:00-17:00</p>
  </div>
</div>
</template>
<script>
export default {
  name: 'systemSupport'
}
</script>
<style lang="scss">
.system-support {
  width: 500px;
  position: relative;
  top: 20%;
  left: 50%;
  margin-left: -250px;
  text-align: center;
  .title{
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 700;
  }
  .content{
    font-size: 16px;
    margin-bottom: 20px;
    font-weight: 700;
  }
  .range {
    margin: 20px auto;
  }
  .footer {
    padding-top: 5px;
    padding-bottom: 5px;
    border-top: 1px solid #dddddd;
    p {
      margin: 20px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/system-support.vue